export const permissionsParser = permissions =>
  Object.entries(permissions).reduce(
    (prev, [key, val]) => ({
      ...prev,
      [key]: val.reduce((p, c) => ({ ...p, ...c }), {}),
    }),
    {},
  );
